import { render, staticRenderFns } from "./CadastrarEditarPerfilTurmaDialog.vue?vue&type=template&id=64f0bebb"
import script from "./CadastrarEditarPerfilTurmaDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarPerfilTurmaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports